/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ key: NonNullable<unknown> }} Tl_Set_Dates_ForInputs */

const en_tl_set_dates_for = /** @type {(inputs: Tl_Set_Dates_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Set dates of ${i?.key}`)
};

const de_tl_set_dates_for = /** @type {(inputs: Tl_Set_Dates_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termine von ${i?.key} setzen`)
};

/**
* | output |
* | --- |
* | "Set dates of {key}" |
*
* @param {Tl_Set_Dates_ForInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_set_dates_for = /** @type {((inputs: Tl_Set_Dates_ForInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Set_Dates_ForInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_set_dates_for(inputs)
	return en_tl_set_dates_for(inputs)
});